









import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'SKLADMISTOOST_ID' },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'SKLADMISTOOST_ID',
			apiProvider,
			emptyObject: { id: null, value: null, text: null },
		};
	},
	methods: {
		dbToBaseMapper(data: Record<string, any>) {
			return {
				id: data.SKLADMISTOOST_ID,
				value: data.TEXT,
				text: data.POPIS,
			};
		},
	},
});
